<div class="modal-header">
  <h4 class="modal-title">
    @if (mode === 'select') {
      Import / Export Templates
    } @else if (mode === 'export') {
      Export Template: {{ selectedTemplateName }}
    } @else {
      Import Template
    }
  </h4>
</div>

<div class="modal-body">
  <!-- Selection Mode -->
  @if (mode === 'select') {
    @if (isLoading) {
      <div class="text-center py-5">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-3">Loading templates...</p>
      </div>
    } @else {
      <div class="selection-section">
        <div class="row">
          <div class="col-md-6">
            <div class="card">
              <div class="card-body text-center">
                <i class="fas fa-upload fa-3x mb-3" aria-hidden="true"></i>
                <h5>Export Template</h5>
                @if (templateOptions.length === 0) {
                  <p class="text-muted">No templates available to export. Create a template first, then return here to export it.</p>
                  <button class="btn btn-secondary" disabled aria-label="No templates available for export">
                    No Templates Available
                  </button>
                } @else {
                  <p class="text-muted">Download a template file to share with other accounts</p>
                  
                  <form [formGroup]="shareForm">
                    <div class="mb-3">
                      <select class="form-select" formControlName="selectedTemplate" aria-label="Select template to export">
                        <option value="">Select template to export</option>
                        @for (template of templateOptions; track template.key) {
                          <option [value]="template.key">{{ template.value }}</option>
                        }
                      </select>
                    </div>
                  </form>
                  
                  <button 
                    class="btn btn-primary" 
                    (click)="selectExport()"
                    [disabled]="!shareForm.get('selectedTemplate')?.value"
                    aria-label="Export selected template">
                    Export Template
                  </button>
                }
              </div>
            </div>
          </div>
          
          <div class="col-md-6">
            <div class="card">
              <div class="card-body text-center">
                <i class="fas fa-download fa-3x mb-3" aria-hidden="true"></i>
                <h5>Import Template</h5>
                <p class="text-muted">Upload a template file from another account</p>
                
                <button class="btn btn-primary" (click)="selectImport()" aria-label="Go to import template form">
                  Import Template
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  }

  <!-- Import Mode -->
  @if (mode === 'import') {
    <div class="import-section">
      <form [formGroup]="shareForm">
        <div class="mb-3">
          <label for="templateFile" class="form-label">Select Template File:</label>
          <input 
            type="file" 
            class="form-control" 
            id="templateFile"
            accept=".json"
            (change)="onFileSelected($event)">
          <div class="form-text">Select a .json template file exported from another account</div>
        </div>
        
        <div class="mb-3">
          <label for="newTemplateName" class="form-label">Template Name:</label>
          <input 
            type="text" 
            class="form-control" 
            id="newTemplateName"
            formControlName="newTemplateName"
            placeholder="Enter name for imported template">
          @if (shareForm.get('newTemplateName')?.invalid && shareForm.get('newTemplateName')?.touched) {
            <div class="text-danger">Template name is required</div>
          }
        </div>
      </form>
    </div>
  }
</div>

<div class="modal-footer">
  @if (mode === 'import') {
    <button type="button" class="btn btn-secondary" (click)="backToSelect()" aria-label="Go back to template selection">
      <i class="fas fa-arrow-left" aria-hidden="true"></i> Back
    </button>
  }
  
  <button type="button" class="btn btn-secondary" (click)="onCancel()" aria-label="Cancel and close dialog">
    Cancel
  </button>
  
  @if (mode === 'import') {
    <button 
      type="button" 
      class="btn btn-primary" 
      (click)="importTemplate()"
      [disabled]="!importFile || !shareForm.get('newTemplateName')?.value || isLoading"
      aria-label="Import selected template file">
      @if (isLoading) {
        <div class="spinner-border spinner-border-sm me-2" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      }
      Import Template
    </button>
  }
</div>
